import { useEffect, useState } from "react";

/**
 * Marca de "acabou de entrar". O login so MARCA: logo depois dele vem a tela de
 * verificacao da sessao, e o painel, ao aparecer, consome a marca (uma vez so).
 * Recarregar a pagina com a sessao ja aberta nao conta como login.
 */
let marcado = false;

export function marcarLoginRecente(): void {
  marcado = true;
}

/** Devolve se havia login recente e limpa, para nao repetir. */
export function consumirLoginRecente(): boolean {
  const havia = marcado;
  marcado = false;
  return havia;
}

/**
 * `true` no painel que abriu logo depois do login. Consome no efeito (e nao no
 * estado inicial): no StrictMode o estado inicial roda duas vezes e a segunda
 * apagaria a marca.
 */
export function useLoginRecente(): boolean {
  const [recente, setRecente] = useState(false);
  useEffect(() => {
    if (consumirLoginRecente()) setRecente(true);
  }, []);
  return recente;
}
